var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "epg-guide" }, [
    _vm.msg ? _c("b", [_vm._v(_vm._s(_vm.msg))]) : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "guide-time" } }, [
      _vm._v(_vm._s(_vm.currentDateFormated))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "trx-1-3",
        class: { "event-info-active": _vm.fullInfo },
        attrs: { id: "event-info" }
      },
      [
        _c("div", { attrs: { id: "channel-name" } }, [
          _vm._v(_vm._s(_vm.currentChannelName))
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "event-name" } }, [
          _vm._v(_vm._s(_vm.currentProgram.title))
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "event-duration" } }, [
          _vm._v(
            _vm._s(_vm.currentProgram.start) +
              " - " +
              _vm._s(_vm.currentProgram.end)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event-progress" }, [
          _c("div", {
            style: { width: _vm.currentEventProgress },
            attrs: { id: "event-inner-progress" }
          })
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "event-text" } }, [
          _vm._v(" " + _vm._s(_vm.programDescription))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "epgguide-table-wrapper" }, [
      _c(
        "table",
        {
          ref: "epgguide",
          class: { "epgguide-inactive": _vm.fullInfo },
          attrs: { id: "epgguide" }
        },
        [
          _c("tbody", { attrs: { id: "epgguide-headline" } }, [
            _c("tr", [
              _c("th", { attrs: { id: "guide-date" } }, [
                _c("div", [_vm._v(_vm._s(_vm.currentTimelineHeaderDate))])
              ]),
              _vm._v(" "),
              _c(
                "th",
                { attrs: { id: "timeline" } },
                [
                  _vm.currentHorizontalPage <= 1
                    ? _c("div", { attrs: { id: "time-position-wrapper" } }, [
                        _c("div", {
                          style: {
                            height: _vm.timelineHeight + "px",
                            marginLeft: _vm.currentTimelinePosition + "%"
                          },
                          attrs: { id: "epg-timeline-position" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.timelines, function(item) {
                    return [
                      _c(
                        "div",
                        {
                          key: item.time,
                          staticClass: "timeline-item",
                          style: { width: item.percent }
                        },
                        [_vm._v(_vm._s(item.time))]
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            { attrs: { id: "epgguide-body" } },
            [
              _vm._l(_vm.channelsPerPage, function(channel) {
                return [
                  _c(
                    "tr",
                    {
                      key: channel._id,
                      attrs: { id: "entry-" + channel.position }
                    },
                    [
                      _c("td", { staticClass: "channel-entry" }, [
                        _vm._v(_vm._s(channel.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "eventlist",
                          attrs: { id: "eventlist-" + channel.position }
                        },
                        [
                          _vm._l(
                            _vm.programByIndex(channel.position - 1),
                            function(program, pindex) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: program.id,
                                    staticClass: "event",
                                    class: { "event-active": program.isActive },
                                    style: { width: program.percent + "%" },
                                    attrs: {
                                      "data-channelindex": channel.position,
                                      "data-eventindex": pindex,
                                      id: "event-" + channel.position
                                    }
                                  },
                                  [_vm._v(_vm._s(program.title))]
                                )
                              ]
                            }
                          )
                        ],
                        2
                      )
                    ]
                  )
                ]
              })
            ],
            2
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "epg-pager" } },
      [
        _c("div", {
          staticClass: "arrow arrow-down float-l",
          class: { "arrow-active": _vm.isDownArrowActive },
          style: _vm.cssImageArrowDown
        }),
        _vm._v(" "),
        _vm._l(_vm.maxChannelPages, function(p) {
          return [
            _c("div", {
              key: p,
              staticClass: "float-l epg-pager-item",
              class: { "epg-pager-active": _vm.currentChannelPageNr === p },
              attrs: { id: "epg-page-" + p }
            })
          ]
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "arrow arrow-up float-l",
          class: { "arrow-active": _vm.isUpArrowActive },
          style: _vm.cssImageArrowUp
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cece038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cece038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EPGGuide.vue
// module id = null
// module chunks = 